import { useOrganizationStore } from "@/store/useOrganizationStore";

const capitalizeWords = (str: string): string => {
  return str
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
};

export const DashboardHeader = () => {
  const { organization } = useOrganizationStore();

  return (
    <div className="mb-8">
      <h2 className="text-2xl font-semibold text-foreground mb-1">
        Hi{" "}
        {capitalizeWords(
          organization?.name || organization?.shortName || "There"
        )}
        , Here's Your Dashboard 👋
      </h2>
      <p className="text-sm text-muted-foreground">
        A quick view of how your business is doing today.
      </p>
    </div>
  );
};
